import { dehydrate, QueryClient } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';

import SuspensePostHydration from '../../../../../components/_molecules/SuspensePostHydration';
import LiveGameViewer from '../../../../../components/_organisms/LiveGameViewer';
import { gameCacheKey } from '../../../../../hooks/useGame';
import CoreAPIService from '../../../../../services/CoreAPIService';
import { detectAndBestEffortSetLanguage } from '../../../../../utils/localisationUtils';

const LivePage = () => (
  <SuspensePostHydration>
    <LiveGameViewer />
  </SuspensePostHydration>
);

export const getServerSideProps: GetServerSideProps = async context => {
  const queryClient = new QueryClient();
  const { gameId } = context.query;
  await queryClient.prefetchQuery({
    queryKey: [gameCacheKey, gameId],
    queryFn: async () => CoreAPIService.getGame(gameId as string),
    staleTime: 1000 * 60 * 60 * 24,
  });

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      ...(await detectAndBestEffortSetLanguage(context, { routeClass: 'app' })),
    },
  };
};
export default LivePage;
